<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <div>
    <v-navigation-drawer
        app
        class="ma-0 pa-0 grey lighten-3"
        clipped
        mini-variant
        mini-variant-width="67"
        permanent
    >
      <v-tooltip :disabled="get_selectors_state" color="trade-blue text-subtitle-1">
        <template v-slot:activator="{on}">
          <v-layout v-on="on" class="pr-2 pt-2 pl-1" row>
            <!-- Search-->
            <v-flex class="d-flex xs12">
              <div v-on="on">
                <help-link help_id="1" class="ml-6 mt-5"></help-link>
              </div>
            </v-flex>

            <span class="caption ml-5 mb-1 mt-4">Filters</span>
            <!--            <span class="caption ml-5 mb-1 mt-4">{{-->
            <!--              $store.state.app.disable_getters-->
            <!--            }}</span>-->

            <!--            //insert below this-->
            <template>
              <template v-for="item in $store.state.tradeDSM.left_sidebar_selector">
                <v-flex :key="item.id" class="d-flex xs12">
                  <v-tooltip right>
                    <template v-slot:activator="{on}">
                      <v-btn
                          v-if="item.tip === 'Products' || item.tip === 'Countries'"
                          id="side-icon"
                          v-on="on"
                          :disabled="!get_selectors_state"
                          class="mt-0"
                          text
                          v-on:click.stop="open_drawer(item.tip)"
                      >
                        <v-badge
                            :content="
                            item.tip === 'Products'
                              ? productsSelectedCount || 0
                              : marketsSelectedCount || 0
                          "
                            :value="
                            item.tip === 'Products'
                              ? productsSelectedCount || 0
                              : marketsSelectedCount || 0
                          "
                            :color="
                            item.tip === 'Products'
                              ? product_bubble_color()
                              : market_bubble_color()
                          "
                            offset-x="10"
                            overlap
                        >
                          <v-icon class="trade-blue-text pa-0 ma-0"
                          >{{ item.icon }}
                          </v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                    <span>{{ item.tip }}</span>
                  </v-tooltip>
                </v-flex>
              </template>
            </template>
          </v-layout>
        </template>
        <span
        >The filters are disabled in this view. Select the Home button to refine
          report.</span
        >
      </v-tooltip>

      <v-layout row>
        <!-- Filters-->
        <template>
          <!--          <span class="caption ml-6 mb-0">Filters</span>-->

          <v-tooltip right :key="filters_selected_text">
            <template v-slot:activator="{on}">
              <v-btn
                  :disabled="!get_selectors_state"
                  class="mt-0 ml-1"
                  text
                  v-on="on"
                  v-on:click.stop="open_drawer('DSM Filters')"
              >
                <v-badge
                    :content="
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .filter_in_progress ||
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .advanced_filters_is_dirty
                      ? '✓'
                      : 0
                  "
                    :value="
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .filter_in_progress ||
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .advanced_filters_is_dirty
                      ? '✓'
                      : 0
                  "
                    :color="main_filter_badge_color"
                    offset-x="10"
                    overlap
                >
                  <v-icon class="pa-0 ma-0">mdi-filter-variant</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span> {{ filters_selected_text }}</span>
          </v-tooltip>

          <span class="caption ml-5 mb-1">Presets</span>
          <v-tooltip right>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  :disabled="!get_selectors_state"
                  class="mt-0 ml-1"
                  text
                  @click="select_custom_filter_open = true"
              >
                <v-badge
                    :content="
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .filter_in_progress &&
                    !$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .advanced_filters_is_dirty
                      ? '✓'
                      : 0
                  "
                    :value="
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .filter_in_progress &&
                    !$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .advanced_filters_is_dirty
                      ? '✓'
                      : 0
                  "
                    color="green"
                    offset-x="-16"
                    offset-y="3"
                    overlap
                >
                </v-badge>
                <v-icon> mdi-filter-variant-plus</v-icon>
              </v-btn>
            </template>
            <span>Load preset filters</span>
          </v-tooltip>
          <v-tooltip right>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  :disabled="!get_selectors_state"
                  class="mt-0 ml-1"
                  text
                  @click="clear_preset_filters(true)"
              >
                <v-icon> mdi-filter-variant-minus</v-icon>
              </v-btn>
            </template>
            <span>Clear preset filters</span>
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  :disabled="!get_selectors_state"
                  class="mt-0 ml-1"
                  text
                  @click="load_product_exclusions"
              >
                <v-badge
                    :content="
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets
                      .load_presets
                      ? '✓'
                      : 0
                  "
                    :value="
                    $store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets
                      .load_presets
                      ? '✓'
                      : 0
                  "
                    color="green"
                    offset-x="10"
                    overlap
                >
                  <v-icon> mdi-playlist-plus</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>{{
                $store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets
                    ? 'Product exclusions are active'
                    : 'Load product exclusions'
              }}</span>
          </v-tooltip>
          <v-tooltip right>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  :disabled="!get_selectors_state"
                  class="mt-0 ml-1"
                  text
                  @click="clear_product_exclusions"
              >
                <v-icon> mdi-playlist-minus</v-icon>
              </v-btn>
            </template>
            <span>Clear product exclusions</span>
          </v-tooltip>
          <!--          <v-btn class="mt-0" disabled text>-->
          <!--            <v-icon class="trade-blue-text pa-0 ma-0 ml-2 ">mdi-minus</v-icon>-->
          <!--          </v-btn>-->
          <span class="caption ml-6">Reset</span>

          <v-tooltip right>
            <template v-slot:activator="{on}">
              <v-btn text @click="reset_products_countries" class="ml-1" v-on="on">
                <v-icon>mdi-alpha-x-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>Clear Product and Market selections (no filter changes).</span>
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  :disabled="!get_selectors_state"
                  class="mt-0 ml-1"
                  text
                  @click="reset_filters_to_preset_state(true)"
              >
                <v-icon> mdi-sync</v-icon>
              </v-btn>
            </template>
            <span>
              Clear user selections and reload default filters and exclusions.
            </span>
          </v-tooltip>

          <v-tooltip right>
            <template v-slot:activator="{on}">
              <v-btn
                  v-on="on"
                  :disabled="!get_selectors_state"
                  class="ml-1 "
                  text
                  @click="reset_filters_to_raw_state()"
              >
                <v-icon> mdi-delete-restore</v-icon>
              </v-btn>
            </template>
            <span>Clear presets (filters & exclusions) and user selections.</span>
          </v-tooltip>
        </template>
      </v-layout>

      <template
          v-if="
          !$store.state.excel_report_generation_in_progress &&
            !$store.state.word_report_generation_in_progress &&
            !$store.state.email_report_generation_in_progress
        "
      >
        <!--  Report Line        -->
        <div
            class="caption ml-3 mt-1"
            v-if="
            ($store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate === '1PMC' ||
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                .report_type_to_generate === '1P1C' ||
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                .report_type_to_generate === 'MP1C') &&
              this.is_run_cube_valid
          "
        >
          Report
        </div>

        <!-- Word report          -->
        <template
            v-if="
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate === '1P1C' ||
              ($store.state.tradeDSM.dsm_filter_setttings.Filters.META
                .report_type_to_generate === '1PMC' &&
                $store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results.cube
                  .length > 0)
          "
        >
          <div>
            <v-tooltip right>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-on="on" class="mt-0" text @click="generate_report('word')">
                  <v-icon class="trade-blue-text mr-3">mdi-microsoft-word</v-icon>
                </v-btn>
              </template>
              <span
              >Download
                {{
                  $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                      .report_type_to_generate === '1P1C'
                      ? 'single product single country'
                      : 'single product multi-country'
                }}
                report</span
              >
            </v-tooltip>
          </div>
        </template>

        <!-- Powerpoint          -->
        <template
            v-if="
            $store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate === 'MP1C' && is_run_cube_valid
          "
        >
          <v-tooltip right>
            <template v-slot:activator="{on, attrs}">
              <v-btn v-on="on" class="mt-0" text @click="generate_report('pptx')">
                <v-icon class="trade-blue-text mr-3">mdi-microsoft-powerpoint</v-icon>
              </v-btn>
            </template>
            <span>Download Powerpoint Report</span>
          </v-tooltip>
        </template>

        <!-- Excel          -->
        <div
            v-if="
            ($store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate === '1PMC' ||
              $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                .report_type_to_generate === '1P1C') &&
              $store.state.current_1PMC_report_seletion !== 'EMF_Overview'
          "
        >
          <v-tooltip right>
            <template v-slot:activator="{on, attrs}">
              <v-btn v-on="on" class="mt-0" text @click="dialog_window_excel_report()">
                <v-icon class="trade-blue-text mr-3">mdi-microsoft-excel</v-icon>
              </v-btn>
            </template>
            <span
            >{{
                this.$store.state.tradeData.report_selections.filter(
                    v => v.value === this.$store.state.current_1PMC_report_seletion,
                )[0]['hover_text']
              }}
            </span>
          </v-tooltip>
        </div>

        <!--        This was comment out untill it is needed again.-->
        <div v-if="crm_action_available() !== false" class="mt-2">
          <span class="caption ml-3 ">CRM</span>
          <v-btn v-on="on" class="" text @click="crm_apply_action">
            <v-icon class="trade-blue-text ">mdi-arrow-expand-left</v-icon>
          </v-btn>
        </div>
      </template>

      <!--      Customer filter selection box-->
      <custom_filter_selection
          :select_custom_filter_open.sync="select_custom_filter_open"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import swal from 'sweetalert';
import html2canvas from 'html2canvas';
import {eventBus} from '@/main';
import calc_reo_table_values from '@/components/trade-dsm-application/mixins/calc_reo_table_values';
import custom_filter_selection
  from '@/components/trade-dsm-application/left-side-bar/custom_filter_loader/custom_filer_selection';
import localforage from 'localforage';
import helpLink from '@/components/application-level/help-system/help-link';
import dialogDownloadWord from '@/components/application-level/helper-components/dialog-download-word.vue';
import {
  clear_crm_action_que,
  clear_crm_request,
  crm_action,
  crm_action_available,
  crm_action_window,
} from '@/components/trade-crm-app/js/crm_url_parameters';

const FileDownload = require('js-file-download');

export default {
  name: 'tradeLeftSideBar',
  components: {
    custom_filter_selection,
    helpLink,
    // dialogDownloadWord
  },
  mixins: [calc_reo_table_values],
  computed: {
    ...mapGetters([
      'get_selectors_state',
      'app_data',
      'user',
      'get_dsm_result',
      'is_run_cube_valid',
      'single_product',
    ]),

    filters_selected_text() {
      // this.get_custom_filter_id();
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .filter_in_progress === true &&
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .advanced_filters_is_dirty === true
      ) {
        return 'Filters are active - click here to change';
      } else if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .filter_in_progress === true
      ) {
        let selection = JSON.parse(localStorage.getItem('custom_filters_selected'));
        return `Customer Filter #${selection['current_value_list_ix'] +
        1} has been applied. [click to change]`;
      } else if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .advanced_filters_is_dirty === true
      ) {
        return 'Filters are active - click here to change';
      } else return 'No Filters are active - click to change';
    },

    main_filter_badge_color() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .filter_in_progress === true &&
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .advanced_filters_is_dirty === true
      ) {
        return 'orange';
      } else if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .filter_in_progress === true
      ) {
        return 'green';
      } else if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .advanced_filters_is_dirty === true
      ) {
        return 'orange';
      } else return 'green';
    },

    template_location() {
      return this.$store.state.user.userServerInfo.user.fields.institution[0].fields
          .template_location;
    },
  },

  data: () => ({
    products: false,
    countries: false,
    dsm_filters: false,
    advanced_filters: false,
    messages_temp: 4,
    dialog_open: false,
    save_name: '',
    selected_standard_filter_id: 0,
    select_custom_filter_open: false, // is the filer box open
  }),

  methods: {
    crm_action_available: crm_action_available,
    ...mapMutations([
      'set_selectors_state',
      'clear_circ_ref_error',
      'set_user_message',
      'set_dsm_filters_from_localforage',
    ]),

    async crm_apply_action() {
      const action = await crm_action_window();
      if (action) {
        clear_crm_request();
        await this.update_results_cube();
      }
    },
    market_bubble_color() {
      if (this.$store.state.market_preselected_by_app === true) {
        return 'green';
      } else {
        return 'orange';
      }
    },
    product_bubble_color() {
      if (this.$store.state.product_preselected_by_app === true) {
        return 'green';
      } else {
        return 'orange';
      }
    },

    get_default_filters() {
      return JSON.parse(localStorage.getItem('custom_filters_selected'));
    },
    reset_products_countries() {
      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products
              .HS6_Code.length > 0 ||
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets
              .C_Code.length > 0
      ) {
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code = [];
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = [];
        this.update_results_cube();
      }
    },

    open_help() {
      // http://devapp.tradeadvisory.co.za:8999/dev/emf-documentation/build/default/
      let SERVER_TYPE = 'production';
      let SERVER_NAME = 'dsm.tradeadvisory.co.za';
      if (process.env.NODE_ENV === 'production') {
        SERVER_TYPE = 'production';
        // SERVER_NAME = "178.62.250.141"
        SERVER_NAME = 'dsm.tradeadvisory.co.za';
      } else {
        SERVER_TYPE = 'dev';
        SERVER_NAME = 'devapp.tradeadvisory.co.za';
      }

      let HELP_VERSION = this.$store.state.user.userServerInfo.user.fields.institution[0]
          .fields.help_version;
      let url = `http://${SERVER_NAME}:8999/${SERVER_TYPE}/emf-documentation/build/${HELP_VERSION}/`;
      console.log(url);
      window.open(url, 'myWindow', 'height=900,width=900');
    },

    get_custom_filter_id() {
      let x = this.$getItem('selected_standard_filter_id');
      x.then(v => {
        this.selected_standard_filter_id = v + 1;
      });
    },

    apply_transaction() {
      this.$store.state.tradeDSM.apply_transaction = !this.$store.state.tradeDSM
          .apply_transaction;
      this.update_results_cube();
    },

    async reset_filters_to_preset_state() {
      this.$store.state.tradeDSM.last_clicked_country_box = null;

      await this.reset_filters('FILTERS_PRESET').then(() => {
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress = true;
        eventBus.$emit('CLEAR_MARKETS_TOP_LIST');
        eventBus.$emit('CLEAR_PRODUCTS_TOP_LIST');
        eventBus.$emit('CLEAR_REO_TABLE');
      });

      this.$store.state.tradeDSM.quick_selectors[1].items = await JSON.parse(
          localStorage.getItem('dsm_codes'),
      );
      this.set_user_message(
          'All presets filters, exclusions and selections have been reset.',
      );
      this.update_mpmc_graphs(); //graphs underneath map
    },
    async load_product_exclusions() {
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets = true;
      await this.update_results_cube();
      this.set_user_message('Product exclusions have been loaded.');
    },
    async clear_product_exclusions() {
      this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.presets.load_presets = false;
      await this.update_results_cube();
      this.set_user_message('Product exclusions have been cleared.');
    },

    async save_context(obj_data) {
      this.save_name = 'MAINTEST';

      await swal({
        text: 'Enter save name',
        content: 'input',
        button: {
          text: 'Save',
          closeModal: false,
        },
      }).then(name => {
        this.save_name = name;
      });

      if (this.save_name.length > 0) {
        let data = {};
        data = obj_data;
        data['file_name'] = this.save_name;

        await this.axios
            .post(this.$store.getters.baseUrl + 'save_request/', data)
            .then(response => console.log(response));
      }
    },
    go_home() {
      // console.log('Going home ...');
      this.$store.commit('set_current_selected_tab', 0);
      this.set_selectors_state(true);
      this.$store.state.app.big_map === true
          ? (this.$store.state.app.big_map = false)
          : (this.$store.state.app.big_map = false);
    },
    open_drawer(id) {
      this.$store.commit('toggleProductsFilter', id === 'Products');
      this.$store.commit('toggleCountriesFilter', id === 'Countries');
      this.$store.commit('toggleMainFilter', id === 'DSM Filters');
      // if (id === 'The Advanced DSM Filters will be rolled out in Q1 2021') {
      //   swal('The Advanced DSM Filters will be rolled out in Q1 2021.');
      // }

      // this.$store.commit('toggleMainFilter', id === 'Main Filters');
    },

    pad(n) {
      return n < 10 ? '0' + n : n;
    },

    generate_pptx_report() {
      this.axios({
        method: 'post',
        baseURL: this.$store.getters.baseUrl,

        url: 'generate_pptx_report/',
        responseType: 'blob',
        data: {},
      })
          // FileDownlaod
          .then(response => {
            // const filename = `ABS_report_for_${this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0]}_${this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.report_type_to_generate}.zip`;
            const filename = `Powerpoint_report_for_${
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                    .products.HS6_Code[0]
            }_${
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                    .report_type_to_generate
            }.pptx`;
            FileDownload(response.data, filename);

            swal('Powerpoint document downloaded to downloads folder.', {
              buttons: false,
              timer: 2000,
            });
            this.$store.state.excel_report_generation_in_progress = false;
            this.set_user_message('Powerpoint file downloaded');
          })
          .catch(() => {
            swal('Error in Powerpoint document generation.', {
              buttons: false,
              timer: 2000,
            });
            this.$store.state.excel_report_generation_in_progress = false;
          })
          .finally(() => {
            this.$store.state.excel_report_generation_in_progress = false;
          });
    },

    async generate_xls_report() {
      let report = this.$store.state.tradeData.report_selections.filter(
          v => v.value === this.$store.state.current_1PMC_report_seletion,
      )[0];

      swal(
          `${report['report_name']} Excel Report Generation Started\n\nPlease be patient`,
          {
            buttons: false,
            timer: 3000,
          },
      );

      // url: 'generate_abs_report/',
      this.$store.state.excel_report_generation_in_progress = true;
      this.set_user_message('Preparing Excel document');

      this.axios({
        method: 'post',
        baseURL: this.$store.getters.baseUrl,

        url: report['report_url'],
        responseType: 'blob',
        data: {
          product_list: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .selections.products.HS6_Code,
          country_list: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code.map(
              c => {
                return {
                  C_Code: c,
                  C_Name: this.codeToMarket(c),
                };
              },
          ),
          institution_name: this.$store.state.user.userServerInfo.user.fields
              .institution[0].fields.institution_name,
          template_directory: this.template_location,
          current_model: this.$store.state.tradeData.report_selection,
          report_type: this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate,
        },
      })
          // FileDownlaod
          .then(response => {
            // const filename = `ABS_report_for_${this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code[0]}_${this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.report_type_to_generate}.zip`;
            const filename = `${report['value']}_report_for_${
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                    .products.HS6_Code[0]
            }_${
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
                    .report_type_to_generate
            }.zip`;
            FileDownload(response.data, filename);
            swal('Excel document downloaded to downloads folder.', {
              buttons: false,
              timer: 2000,
            });
            this.$store.state.excel_report_generation_in_progress = false;
            this.set_user_message('Excel file downloaded');
          })
          .catch(() => {
            swal('Error in Excel document generation.', {
              buttons: false,
              timer: 2000,
            });
            this.$store.state.excel_report_generation_in_progress = false;
          })
          .finally(() => {
            this.$store.state.excel_report_generation_in_progress = false;
          });
    },

    generate_report(report_type) {
      // route to the correct report function
      switch (
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META
              .report_type_to_generate
          ) {
        case '1P1C':
          this.dialog_window_1p1c_report(report_type);
          break;
        case 'MPMC':
          this.generate_mpmc_snapshot_report(report_type); // not implemented yet
          break;
        case '1PMC':
          this.dialog_window_1pmc_report(report_type);
          break;
        case 'MP1C':
          this.dialog_window_mp1c_report(report_type);
      }
    },

    getCircularReplacer: () => {
      const seen = new WeakSet();
      return (key, value) => {
        if (typeof value === 'object' && value !== null) {
          if (seen.has(value)) {
            return;
          }
          seen.add(value);
        }
        return value;
      };
    },

    async dialog_window_1p1c_report(report_type) {
      // bind props
      console.log(report_type);
      this.$store.state.app.activeDialogComponentProps = {
        ms_office_type: 'Word',
        download_func: this.generate_1p1c_snapshot_report,
        email_func: this.generate_1p1c_snapshot_report,
        show_sections: false,
        show_email_button: true,
        show_mobile: true,
        show_crm_button: await crm_action_available(),
      };
      this.$store.state.app.activeDialogComponent = dialogDownloadWord;
    },

    dialog_window_1pmc_report(report_type) {
      console.log(report_type);
      this.$store.state.app.activeDialogComponentProps = {
        ms_office_type: 'Word',
        download_func: this.generate_1pmc_snapshot_report,
        email_func: this.generate_1pmc_snapshot_report,
        show_sections: true,
        show_email_button: true,
        show_mobile: true,
      };
      this.$store.state.app.activeDialogComponent = dialogDownloadWord;
    },

    // eslint-disable-next-line no-unused-vars
    dialog_window_mp1c_report(report_type) {
      // console.log(report_type);
      this.$store.state.app.activeDialogComponentProps = {
        ms_office_type: 'Powerpoint',
        download_func: this.generate_mp1c_snapshot_report,
        email_func: this.generate_mp1c_snapshot_report,
        show_sections: false,
        show_mobile: false,
        show_email_button: true,
      };
      this.$store.state.app.activeDialogComponent = dialogDownloadWord;
    },

    dialog_window_excel_report(report_type) {
      console.log(report_type);
      this.$store.state.app.activeDialogComponentProps = {
        ms_office_type: 'Excel',
        download_func: this.generate_xls_report,
        email_func: null,
        show_email_button: false,
        show_sections: false,
        show_mobile: false,
      };
      this.$store.state.app.activeDialogComponent = dialogDownloadWord;
    },

    upload_to_crm: async function (response, filename) {
      const formData = new FormData();
      const file = new File([response.data], filename, {
        type: response.data.type,
      });

      formData.append('file', file); // Assuming response.data is the Word document (Blob or File object)

      const process_data = await localforage.getItem('crm');
      formData.append('process_data', JSON.stringify(process_data));
      for (let pair of formData.entries()) {
        console.log(pair[0] + ':', pair[1]);
      }

      if (process_data && process_data['dsm_app_redirect_url_to_crm']) {
        const uri = process_data['dsm_app_redirect_url_to_crm'];

        // Make POST request
        this.axios
            .post(uri + 'incoming/trade_dsm_file_upload/', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              console.log('File Uploaded Success'); // Handle success
              clear_crm_action_que();
              window.open(uri + 'crm/process/' + process_data['process_id'] + '/', '_blank');
              console.log(uri + 'flow/process_export_market_report/');
              console.log(response); // Handle success
            })
            .catch(error => {
              console.error(error); // Handle error
            });
      } else {
        console.warn('process_data is missing or does not contain dsm_app_redirect_url_to_crm');
      }
    },

    generate_1p1c_snapshot_report: async function (report_type, crm_upload = false) {
      await this.set_selectors_state(false);
      let data = this.$store.getters.get_1p1c_results;

      // insert update to doc here
      // -------------------------
      data[
          'history_plot_data_total'
          ] = this.$store.state.tradeDSM.dsm_filter_setttings.results['hist_impexp_total'];

      data['history_export_share'] = (this.get_dsm_result['TW_Share_Prov'] * 100).toFixed(
          2,
      );

      if (
          this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult &&
          this.$store.state.tradeDSM.dsm_filter_setttings.results.dsmresult[0]['result'] !==
          null
      ) {
        this.report_generation_done = false;

        if (report_type === 'word') {
          this.word_doc_preparing = true;
        }

        if (report_type === 'email') {
          this.word_doc_emailing = true;
          this.word_doc_preparing = true;
        }

        const url = this.$store.getters.baseUrl;

        data['template'] = this.template_location;
        data['user'] = this.$store.state.user.userServerInfo;
        data['fullname'] = this.$store.state.user.userServerInfo.user['fullname'];

        data['target_market'] = this.$store.getters.countriesSelectorList.filter(
            c =>
                c['C_Code'] ===
                this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                    .markets.C_Code[0],
        )[0]['C_Name'];

        data['hs6_description'] = this.hs6_codeToDescription(this.single_product);

        data['home_market'] = this.app_data['selectedHomeCountry'];
        data['sub_model_name'] = this.$store.state.app.selectedModelName;
        data['report_type'] = report_type;
        data['magnitude'] = this.app_data['value_mulitplier'];
        data['exchange_rate_tw'] = this.app_data['exchange_rate'];
        data[
            'untapped_potential'
            ] = this.$store.state.tradeDSM.dsm_filter_setttings.Product_Combinations.results.trade_value;
        data['user_job_description'] = this.$store.state.user.userServerInfo['user'][
            'fields'
            ]['user_job_description'];
        // realistic opportunity
        let r = this.$store.getters.getDsmAppState.dsm_filter_setttings.results
            .dsmresult[0];
        let opp =
            r['REO_col'] > 0 &&
            r['REO_row'] > 0 &&
            r['F2_Select'] &&
            r['F31_Select'] &&
            r['F32_Select'];
        data['realistic_opportunity'] = opp;

        data['Market_Rank'] = r['Market_Rank'];
        data['Market_REO_Count'] = r['Market_REO_Count'];

        data[
            'dsm_results'
            ] = this.$store.getters.getDsmAppState.dsm_filter_setttings.results.dsmresult[0];

        if (crm_upload === true) {
          data['crm'] = await crm_action();
        }

        if (report_type === 'word') {
          swal(
              'Document generation in progress.\n\nPlease be patient.This step can take some time.',
              {
                buttons: false,
                closeOnClickOutside: false,
                icon: 'info',
                className: 'swal-modal',
                closeOnEsc: false,
              },
          );
        } // Word Report?
        if (report_type === 'email') {
          await swal('Document emailing in progress', {buttons: false, timer: 2000});
          this.go_home();
        } // Email Report

        this.axios({
          method: 'post',
          baseURL: url,
          url: 'generate_1p1c_report/',
          responseType: report_type === 'word' ? 'blob' : '', //blob type for file
          data: data,
        }) // Now request
            // FileDownlaod
            .then(async response => {
              if (report_type === 'word') {
                let d = new Date();
                let filename = `${d.getFullYear()}_${this.pad(d.getMonth() + 1)}_${this.pad(
                    d.getDate(),
                )}_Snapshot_${data['home_market']}_${data['target_market']}_${
                    this.$store.getters.getDsmAppState.dsm_filter_setttings.Filters.META
                        .selections.products.HS6_Code[0]
                }.docx`;
                swal.close();
                swal('Document downloaded to downloads folder.', {
                  buttons: false,
                  timer: 2000,
                });

                FileDownload(response.data, filename);

                // post to filesystme on CRM
                // Create FormData object
                //
                if (crm_upload === true) {
                  await this.upload_to_crm(response, filename);
                } else console.log('no uploading to crm');

                this.word_doc_preparing = false;
                this.word_doc_downloaded = true;
                this.report_generation_done = true;
                this.go_home();
              }
              if (report_type === 'email') {
                this.word_doc_emailing_success = true;
                swal('Document emailed to user email adress.', {
                  buttons: false,
                  timer: 2000,
                });
                this.go_home();
              }

              // this.loading = false;
            })
            .catch(e => {
              swal.close();
              swal('Document generation error.', {
                buttons: false,
                timer: 2000,
              });
              console.log(e);

              this.html_doc_preparing = false;
              this.report_generation_done = false;
              swal('There was an error with the document generation process');
            }); //then;
      }
    },

    generate_1pmc_snapshot_report: async function (report_type, crm_upload = false) {
      this.clear_circ_ref_error();
      await window.scroll(0, 0);

      await this.$removeItem('1pmc-backup');

      this.set_user_message('Starting report generation');
      let messages_dummy = [
        'Selecting customer template',
        'Creating temporary files',
        'Generating unique identifier',
        'Generating section 1',
        'Generating section 2',
        'Generating section 3',
        'Generating section 4',
        'Generating section 5',
        'Generating section 6',
        'Generating section 7',
        'Generating section 8',
        'Generating section 9',
        'Generating section 10',
        'Writing data files',
        'Updating and linking graphs',
        'Adding images blocks 1/5',
        'Adding images blocks 2/5',
        'Adding images blocks 3/5',
        'Adding images blocks 4/5',
        'Adding images blocks 5/5 ',
        'Adding images blocks 6/8 ',
        'Adding images blocks 7/8 ',
        'Adding images blocks 8/8 ',
        'Removing unwanted sections',
        'Adding maps',
        'Adding REO table',
        'Adding filters',
        'Interpreting results',
        'Adding interpretation text',
        'Creating download file',
        'Cleaning up',
      ];
      let i = 0;
      let messageHandler = setInterval(() => {
        this.set_user_message(messages_dummy[i]);
        i += 1;
        if (i === messages_dummy.length - 1) {
          i = 0;
        }
      }, 1500);

      // eslint-disable-next-line no-constant-condition
      if (true) {
        this.report_generation_done = false;

        if (report_type === 'word' || report_type == 'pptx') {
          this.word_doc_preparing = true;
          this.$store.state.word_report_generation_in_progress = true;
        }

        if (report_type === 'email') {
          this.word_doc_emailing = true;
          this.word_doc_preparing = true;
          this.$store.state.email_report_generation_in_progress = true;
        }

        if (report_type === 'email' || report_type === 'word' || report_type === 'pptx') {
          const url = this.$store.getters.baseUrl;

          let data = {};
          this.clear_circ_ref_error();

          await this.$setItem(
              '1pmc-backup',
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters,
          );

          data['1PMC'] = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;
          data['1PMC'][
              'home_market_code'
              ] = this.$store.getters.countriesSelectorList
              .filter(
                  country => country['C_Name'] === this.$store.state.app.selectedHomeCountry,
              )
              .map(v => v['C_Code'])[0];

          data[
              'product_details'
              ] = this.$store.state.tradeDSM.quick_selectors[1].items.filter(
              v =>
                  v['HS6_Code'] ===
                  data['1PMC']['META']['selections']['products']['HS6_Code'][0],
          );
          data['exchange_rate_tw'] = this.app_data['exchange_rate'];
          data[
              'exchange_rate_non_tw_report'
              ] = this.$store.state.user.userServerInfo.non_tw_exchange_rate.filter(
              v => v['Currency'] === this.app_data.exchange_rate['Currency'],
          );
          // alert(this.app_data.exchange_rate['Currency']);

          data['selected_currency'] = this.$store.state.app.exchange_rate[
              'Currency'
              ].slice(0, 3);
          data['template'] = this.template_location;
          data['user'] = this.$store.state.user.userServerInfo;
          data['fullname'] = this.$store.state.user.userServerInfo.user['fullname'];
          data['home_market'] = this.app_data['selectedHomeCountry'];
          data[
              'include_overview_sections_in_report'
              ] = this.$store.state.app.include_overview_sections_in_report;
          //
          data['1PMC']['META']['query_results']['top6_with_names'] = data['1PMC']['META'][
              'query_results'
              ]['top6'].map(v => {
            return {
              Trade_Value: v['Trade_Value'],
              Supplying_Market: this.codeToMarket(v['Supplying_Market']),
              C_Code: v['Supplying_Market'],
            };
          });

          // console.log(data['1PMC']['META']['query_results']['top6_with_names']);
          data['sub_model_name'] = this.$store.state.app.selectedModelName;
          data['report_type'] = report_type;
          data['magnitude'] = this.app_data['value_mulitplier'];

          data['user_job_description'] = this.$store.state.user.userServerInfo['user'][
              'fields'
              ]['user_job_description'];

          // add crm data to request
          if (crm_upload === true) {
            data['crm'] = await crm_action();
          }

          data['total_import_exports'] =  this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.query_results[
                'dsm_history_total_world_sum'
              ]


          // add image
          await html2canvas(document.getElementById('mpmc_map'), {
            useCORS: true,
            allowTaint: false,
            letterRendering: true,
            profile: true,
          }).then(canvas => {
            this.image_uri = canvas.toDataURL('image/png');
            const image_base64 = this.image_uri.replace(
                /^data:image\/(png|jpg);base64,/,
                '',
            );

            data['map'] = image_base64;
          });

          if (report_type === 'word' || report_type === 'pptx') {
            swal(
                'Document generation in progresss.\n\nPlease be patient. This step can take some time.',
                {buttons: false, timer: 2000},
            );
          }
          if (report_type === 'email') {
            swal('Document emailing in progress', {buttons: false, timer: 2000});
          }

          //reset backup
          // this.set_dsm_filters(JSON.parse(window.sessionStorage.getItem('backup')));

          await this.set_dsm_filters_from_localforage(await this.$getItem('1pmc-backup'));

          this.axios({
            method: 'post',
            baseURL: url,
            url: 'generate_1pmc_report/',
            responseType: 'blob',
            data: data,
          })
              // FileDownlaod
              .then(async response => {
                this.html_doc_preparing = false;
                if (report_type === 'word' || report_type === 'pptx') {
                  swal.close();
                  let d = new Date();

                  let filename = '';
                  if (report_type === 'pptx') {
                    filename = `${d.getFullYear()}_${this.pad(d.getMonth() + 1)}_${this.pad(
                        d.getDate(),
                    )}_P1MC_${data['home_market']}_${
                        data['1PMC']['META']['selections']['products']['HS6_Code'][0]
                    }.pptx`;
                  } else {
                    filename = `${d.getFullYear()}_${this.pad(d.getMonth() + 1)}_${this.pad(
                        d.getDate(),
                    )}_P1MC_${data['home_market']}_${
                        data['1PMC']['META']['selections']['products']['HS6_Code'][0]
                    }.docx`;
                  }

                  FileDownload(response.data, filename);
                  this.set_user_message('Document downloaded to downloads folder');
                  swal('Document downloaded to downloads folder.', {
                    buttons: false,
                    timer: 2000,
                  });

                  this.word_doc_preparing = false;
                  this.word_doc_downloaded = true;
                  this.report_generation_done = true;
                  swal('Document downloaded to downloads folder.', {
                    buttons: false,
                    timer: 2000,
                  });
                  this.$store.state.word_report_generation_in_progress = false;

                  if (crm_upload) {
                    await this.upload_to_crm(response, filename);
                  }
                }
                if (report_type === 'email') {
                  this.word_doc_emailing_success = true;
                  this.set_user_message('Document emailed');
                  this.$store.state.email_report_generation_in_progress = false;
                  swal.close();
                  swal('Document emailed to user email address.', {
                    buttons: false,
                    timer: 2000,
                  });
                }
              })
              .catch(e => {
                console.log(e);
                this.html_doc_preparing = false;
                this.report_generation_done = false;
                swal('There was an error with the document generation process');
                this.set_user_message('');
                this.$store.state.word_report_generation_in_progress = false;
                this.$store.state.email_report_generation_in_progress = false;
              })
              .finally(async () => {
                clearInterval(messageHandler);
                await this.$removeItem('1pmc-backup');
              });
        } else {
          this.html_doc_preparing = false;
          clearInterval(messageHandler);
          await this.$removeItem('1pmc-backup');
        }
      }
    },

    generate_mp1c_snapshot_report: async function (
        report_type,
        report_instructions = null,
    ) {
      this.clear_circ_ref_error();
      await window.scroll(0, 0);

      // await window.sessionStorage.removeItem('backup');
      await this.$removeItem('mp1c-backup');

      this.set_user_message('Starting report generation');

      // eslint-disable-next-line no-constant-condition
      if (true) {
        this.report_generation_done = false;

        if (report_type === 'word' || report_type === 'pptx') {
          this.word_doc_preparing = true;
          this.$store.state.word_report_generation_in_progress = true;
        }

        if (report_type === 'email') {
          this.word_doc_emailing = true;
          this.word_doc_preparing = true;
          this.$store.state.email_report_generation_in_progress = true;
        }

        if (report_type === 'email' || report_type === 'word' || report_type === 'pptx') {
          const url = this.$store.getters.baseUrl;

          let data = {};
          // let selection = null;
          // console.log(selection);

          this.clear_circ_ref_error();

          //backup
          // window.sessionStorage.setItem(
          //   'backup',
          //   JSON.stringify(this.$store.state.tradeDSM.dsm_filter_setttings.Filters),
          // );
          await this.$setItem(
              'mp1c-backup',
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters,
          );

          data['report_instructions'] = report_instructions;
          data['MP1C'] = this.$store.state.tradeDSM.dsm_filter_setttings.Filters;
          data['MP1C'][
              'home_market_code'
              ] = this.$store.getters.countriesSelectorList
              .filter(
                  country => country['C_Name'] === this.$store.state.app.selectedHomeCountry,
              )
              .map(v => v['C_Code'])[0];

          data[
              'product_details'
              ] = this.$store.state.tradeDSM.quick_selectors[1].items.filter(
              v =>
                  v['HS6_Code'] ===
                  data['MP1C']['META']['selections']['products']['HS6_Code'][0],
          );
          data['exchange_rate_tw'] = this.app_data['exchange_rate'];
          data[
              'exchange_rate_non_tw_report'
              ] = this.$store.state.user.userServerInfo.non_tw_exchange_rate.filter(
              v => v['Currency'] === this.app_data.exchange_rate['Currency'],
          );

          data['selected_currency'] = this.$store.state.app.exchange_rate[
              'Currency'
              ].slice(0, 3);
          data['template'] = this.template_location;
          data['user'] = this.$store.state.user.userServerInfo;
          data['fullname'] = this.$store.state.user.userServerInfo.user['fullname'];
          data['home_market'] = this.app_data['selectedHomeCountry'];
          data['target_market'] = this.codeToMarket(
              this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
                  .markets.C_Code[0],
          );
          data[
              'target_market_code'
              ] = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code[0];

          data['conversion_factor'] = this.value_convertion;
          data[
              'include_overview_sections_in_report'
              ] = this.$store.state.app.include_overview_sections_in_report;
          //
          data['MP1C']['META']['query_results']['top6_with_names'] = data['MP1C']['META'][
              'query_results'
              ]['top6'].map(v => {
            return {
              Trade_Value: v['Trade_Value'],
              Supplying_Market: this.codeToMarket(v['Supplying_Market']),
              C_Code: v['Supplying_Market'],
            };
          });

          // console.log(data['MP1C']['META']['query_results']['top6_with_names']);
          data['sub_model_name'] = this.$store.state.app.selectedModelName;
          data['sub_model_number'] = this.$store.state.app.selectedModelVersion;
          data['report_type'] = report_type;
          data['magnitude'] = this.app_data['value_mulitplier'];

          data['user_job_description'] = this.$store.state.user.userServerInfo['user'][
              'fields'
              ]['user_job_description'];

          data['reo_table_data'] = await this.calc_reo_data('cube_HS6_Code');

          if (report_type === 'word' || report_type === 'pptx') {
            swal(
                'Document generation in progresss.\n\nPlease be patient. This step can take some time.',
                // {buttons: false, timer: 2000},
            );
          }
          if (report_type === 'email') {
            swal('Document emailing in progress', {buttons: false, timer: 2000});
          }

          //reset backup
          // this.set_dsm_filters(JSON.parse(window.sessionStorage.getItem('backup')));
          this.set_dsm_filters_from_localforage(await this.$getItem('mp1c-backup'));

          this.axios({
            method: 'post',
            baseURL: url,
            url: 'generate_1pmc_report_pptx/',
            responseType: 'blob',
            data: data,
          })
              // FileDownlaod
              .then(response => {
                this.html_doc_preparing = false;
                if (report_type === 'word' || report_type === 'pptx') {
                  let d = new Date();

                  let filename = '';
                  if (report_type === 'pptx') {
                    filename = `${d.getFullYear()}_${this.pad(d.getMonth() + 1)}_${this.pad(
                        d.getDate(),
                    )}_DSM_Presentation_${this.codeToMarket(
                        data['MP1C']['META']['selections']['markets']['C_Code'][0],
                    )}_TopREOs.pptx`;
                  } else {
                    filename = `${d.getFullYear()}_${this.pad(d.getMonth() + 1)}_${this.pad(
                        d.getDate(),
                    )}_P1MC_${data['home_market']}_${
                        data['MP1C']['META']['selections']['products']['HS6_Code'][0]
                    }.docx`;
                  }

                  FileDownload(response.data, filename);
                  this.set_user_message('Document downloaded to downloads folder');
                  swal('Document downloaded to downloads folder.', {
                    buttons: false,
                    timer: 2000,
                  });
                  swal.close();
                  this.word_doc_preparing = false;
                  this.word_doc_downloaded = true;
                  this.report_generation_done = true;
                  swal('Document downloaded to downloads folder.', {
                    buttons: false,
                    timer: 2000,
                  });
                  this.$store.state.word_report_generation_in_progress = false;
                }
                if (report_type === 'email') {
                  this.word_doc_emailing_success = true;
                  this.set_user_message('Document emailed');
                  this.$store.state.email_report_generation_in_progress = false;
                  swal.close();
                  swal('Document emailed to user email address.', {
                    buttons: false,
                    timer: 2000,
                  });
                }
              })
              // eslint-disable-next-line no-unused-vars
              .catch(e => {
                this.html_doc_preparing = false;
                this.report_generation_done = false;
                swal('There was an error with the document generation process');
                this.set_user_message('');
                this.$store.state.word_report_generation_in_progress = false;
                this.$store.state.email_report_generation_in_progress = false;
              })
              .finally(async () => {
                await this.$removeItem('mp1c-backup');
              });
        } else {
          this.html_doc_preparing = false;
        }
      }
    },

    generate_mpmc_snapshot_report: async function (report_type) {
      alert('Placeholder for: MPMC - ' + report_type);
    },
  }, //methods
};
</script>

<!--<style scoped></style>-->
